import { render, staticRenderFns } from "./MarketplaceProductsTableSection.vue?vue&type=template&id=3dbd2cae&scoped=true"
import script from "./MarketplaceProductsTableSection.vue?vue&type=script&lang=js"
export * from "./MarketplaceProductsTableSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dbd2cae",
  null
  
)

export default component.exports